
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2921',
  depVersions: {
  "customer-portal-app": "static-1.2921",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9858",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25960",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5793",
  "hs-test-utils": "static-1.8224",
  "hub-http": "static-1.6418",
  "hub-http-shared-msw-handlers": "static-1.10440",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18799",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11674",
  "I18n": "static-7.1649",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6655",
  "payment-link-components": "static-1.23973",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7296",
  "quartz-core": "static-1.6515",
  "quartz-i18n": "static-1.971",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10410",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5480",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20168",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18257",
  "ui-components-test-utils": "static-1.5811",
  "UIComponents": "static-3.8620",
  "foundations-assets": "static-1.5075",
  "foundations-components": "static-1.8307",
  "foundations-theming": "static-1.4639",
  "foundations-theming-specialty": "static-1.2355",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1272",
  "quartz-config": "static-1.1074",
  "quartz-routing": "static-1.726",
  "quick-fetch": "static-1.4057",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-aeastham-base-reporter-resolved-tracking.4",
  "rpc-client-utils": "static-1.4858",
  "sanitize-text": "static-1.8346",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4956",
  "ui-addon-react-router-dom": "static-1.9733",
  "usage-tracker": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-anonymous": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.5",
  "video-components-external": "static-1.11919",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3538",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3573",
  "quartz-webpack": "static-1.3520",
  "bend-plugin-quartz-routing": "static-1.374",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7880",
  "frontend-preferences-client": "static-1.8126",
  "laboratory-lib": "static-3.7351",
  "onboarding-scopes": "static-1.6659",
  "seat-types-lib": "static-1.458",
  "ui-addon-opt": "static-4.8561",
  "HeadJS": "static-2.780",
  "hs-test-utils-bend-plugin": "static-1.3335",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.220",
  "ts-schema": "static-1.4219",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8056",
  "content-media-capture": "static-1.5146",
  "cssUtils": "static-1.849",
  "customer-data-ui-utilities": "static-1.10025",
  "file-manager-components": "static-1.24209",
  "HubStyle": "static-2.11981",
  "knowledge-content-types": "static-1.8591",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10085",
  "ui-addon-i18n": "static-1.11346",
  "ui-business-units-lib": "static-1.9280",
  "ui-shepherd-react": "static-3.10461",
  "video-data-lib": "static-1.35577",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4524",
  "commerce-tours-lib": "static-1.6465",
  "customer-data-properties": "static-1.52263",
  "getting-started-shared-tasks": "static-1.18993",
  "growth-onboarding-reliability": "static-1.5283",
  "onboarding-tours": "static-1.16968",
  "reference-resolvers-lite": "static-1.8297",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9276",
  "user-context": "static-1.5311",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.857",
  "hubspotter-http": "static-1.4790",
  "icons": "static-2.667",
  "mobile-manifest-mixins": "static-1.554",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.971",
  "quartz-head": "static-1.961",
  "quartz-test": "static-1.971",
  "quartz-tracking": "static-1.675",
  "trellis-components": "static-1.2348",
  "ui-fonts": "static-1.936",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.5",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9626",
  "data-token-picker": "static-1.16748",
  "FileManagerLib": "static-1.39849",
  "property-translator": "static-1.5595",
  "atom": "static-1.5276",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6208",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5790",
  "react-create-root-preference": "static-1.49",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1211",
  "bend-plugin-foundations-components": "static-1.4576",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2329",
  "bend-plugin-foundations-theming": "static-1.3122",
  "foundations-theming-base": "static-1.3624",
  "stylex": "static-1.37",
  "interframe": "static-3.4956",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1-session-replay-endpoint-migration.5",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.268",
  "chirp-fetch": "static-1.2087",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4677",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4853",
  "content-media-composition-data-lib": "static-1.12950",
  "content-media-compositions": "static-2.16957",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4347",
  "magpie-lib": "static-1.5692",
  "magpie-types": "static-1.5152",
  "media-bridge-lib": "static-1.19267",
  "bender-build-tools": "static-1.3321",
  "usage-tracker-public": "static-1-session-replay-endpoint-migration.5",
  "inbound-db-properties-service-client": "static-1.3985",
  "superstore": "static-1.4958",
  "feedback-loader": "static-1.29658",
  "ai-components-ui-library": "static-1.9459",
  "ui-addon-video-player": "static-1.8906",
  "ui-coaching-tips": "static-1.29112",
  "ContentUtils": "static-1.68942",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4625",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4815",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1423",
  "copilot-toolkit": "static-1.11646",
  "avatar-components": "static-1.2698",
  "navigation-messaging": "static-1.7911",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8376",
  "commerce-products-lib": "static-1.10276",
  "crm-message-bus": "static-1.43539",
  "growth-data-modal": "static-1.5750",
  "hubspot-apollo-client": "static-1.5078",
  "onboarding-tours-client": "static-1.5182",
  "batch-promise": "static-1.1745",
  "calling-global-api": "static-1.65181",
  "calling-internal-common": "static-1.31514",
  "calling-lifecycle-internal": "static-1.66563",
  "calling-lifecycle-messages": "static-1.58857",
  "conditional-properties-service-client": "static-1.3936",
  "crm-links": "static-1.6517",
  "crm-index-visualization-core": "static-1.4399",
  "crm-pipelines-api-client-types": "static-1.4277",
  "customer-data-objects-ui-components": "static-1.13233",
  "customer-data-properties-shared-msw-handlers": "static-1.9767",
  "customer-data-property-utils": "static-1.8296",
  "external-options-client-types": "static-1.4266",
  "formula-editor": "static-1.14602",
  "framework-data-schema-resolvers": "static-1.7094",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.379",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4356",
  "meetings-icalendar-utils-lib": "static-1.831",
  "multi-currency-client-types": "static-1.3830",
  "object-builder-ui-client": "static-1.49394",
  "pipeline-validation-client-types": "static-1.4106",
  "property-value-citations": "static-1.2877",
  "pulse": "static-1.816",
  "smart-property-lib": "static-1.8090",
  "tiered-pricing": "static-1.1768",
  "topics-actions-lib": "static-1.354",
  "ui-addon-form-validation": "static-1.11190",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3261",
  "growth-onboarding-next-action-utils": "static-1.2492",
  "navigation-components": "static-1.18584",
  "onboarding-tours-utils": "static-1.1034",
  "ui-shepherd-tracker": "static-1.7842",
  "ui-universal-auth": "static-1.9217",
  "getting-started-shared-tasks-store": "static-1.18111",
  "hubspotter-http-shared-msw-handlers": "static-1.10438",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.5",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1151",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6206",
  "FileManagerCore": "static-1.39708",
  "FileManagerImages": "static-1.37360",
  "video-components": "static-1.13921",
  "foundations-components-legacy": "static-1.1332",
  "purchase-motions-api": "static-1.6211",
  "signup-constants": "static-1.19367",
  "signup-ui-url-generator": "static-2.8258",
  "reactive-lib": "static-1.923",
  "simple-logging-lib": "static-1.3250",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22326",
  "growth-onboarding-feedback-components": "static-1.6781",
  "cms-field-types": "static-1.5015",
  "content-icons-ui": "static-1.2286",
  "integrations-lib": "static-1.16778",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.701",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.976",
  "customer-data-tracking": "static-1.7084",
  "products-iframe-lib": "static-1.8401",
  "products-ui-components-shared-msw-handlers": "static-1.10822",
  "restore-request-side-panel-lib": "static-1.1402",
  "onboarding-data-sync-lib": "static-1.2310",
  "hubspot-apollo-cache": "static-1.537",
  "calling-error-reporting": "static-1.31521",
  "shared-worker-versioning": "static-1.11238",
  "calling-usage-tracker": "static-1.6740",
  "voice-sms-access-library": "static-1.1716",
  "conversations-skeleton-state": "static-1.7448",
  "location-customization-utils-lib": "static-1.9863",
  "crm-index-associations-lib": "static-1.6641",
  "framework-data-schema-quick-fetch": "static-1.6999",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10523",
  "redux-toolkit": "static-1.7",
  "sales-views-client-types": "static-1.4457",
  "bark-lib": "static-1.16694",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6087",
  "react-codemirror": "static-1.10839",
  "fdsr-migration-layer": "static-1.213",
  "framework-builder-read-service-client": "static-1.4146",
  "persist-promise": "static-1.3902",
  "event-emitter": "static-1.1150",
  "bend-plugin-pulse": "static-1.319",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.504",
  "fsm": "static-1.3932",
  "policy-lib": "static-1.6988",
  "react-tinymce": "static-1.55770",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10586",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54896",
  "tinymce-plugins": "static-1.58010",
  "tinymce-themes": "static-1.56866",
  "growth-onboarding-next-action-components": "static-1.2520",
  "user-context-client": "static-1.4751",
  "nest": "static-1.436",
  "unified-auth-core-lib": "static-1.1013",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4732",
  "video-embed": "static-1.36411",
  "social-insights-client-types": "static-1.22589",
  "flux-actions": "static-1.354",
  "integrations-error-boundary-lib": "static-1.14193",
  "integrations-tracking-lib": "static-1.5807",
  "native-integrations-shared-strings": "static-1.7978",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10565",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.731",
  "InboxConnectUtils": "static-4.15351",
  "meetings-connect-utils-lib": "static-1.7805",
  "calling-orchestration-schema": "static-1.36493",
  "crm-record-cards-service-types": "static-1.3723",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16148",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4707",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3241",
  "tinymce-data": "static-1.40981",
  "ui-addon-sales-email": "static-1.5412",
  "layout-dnd-components": "static-1.12819",
  "layout-dnd-utils": "static-1.11794",
  "ui-brand-identity-lib": "static-1.16012",
  "NamespacedHubStyle": "static-2.9190",
  "outpost": "static-1.4366",
  "universal-page-editor-lib": "static-1.3211",
  "adobe-sign-auth-lib": "static-1.246",
  "ads-unified-auth-lib": "static-1.764",
  "google-sheets-integration-lib": "static-1.823",
  "microsoft-drive-integration-lib": "static-1.929",
  "surveymonkey-integration-lib": "static-1.268",
  "slack-ui-library": "static-1.10598",
  "ContentData": "static-1.69017",
  "layout-data-lib": "static-1.10119",
  "advanced-menus-core": "static-1.15447",
  "advanced-menus-lib": "static-1.12341",
  "ExportDialog": "static-6.10579",
  "ui-memberships-settings-lib": "static-1.34601",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15446",
  "simple-menus-lib": "static-1.16963"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2921",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9858",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25960",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5793",
  "hs-test-utils": "/hs-test-utils/static-1.8224",
  "hub-http": "/hub-http/static-1.6418",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10440",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18799",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11674",
  "I18n": "/I18n/static-7.1649",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6655",
  "payment-link-components": "/payment-link-components/static-1.23973",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7296",
  "quartz-core": "/quartz-core/static-1.6515",
  "quartz-i18n": "/quartz-i18n/static-1.971",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10410",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5480",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20168",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18257",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5811",
  "UIComponents": "/UIComponents/static-3.8620",
  "foundations-assets": "/foundations-assets/static-1.5075",
  "foundations-components": "/foundations-components/static-1.8307",
  "foundations-theming": "/foundations-theming/static-1.4639",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2355",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1272",
  "quartz-config": "/quartz-config/static-1.1074",
  "quartz-routing": "/quartz-routing/static-1.726",
  "quick-fetch": "/quick-fetch/static-1.4057",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-aeastham-base-reporter-resolved-tracking.4",
  "rpc-client-utils": "/rpc-client-utils/static-1.4858",
  "sanitize-text": "/sanitize-text/static-1.8346",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4956",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9733",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.5",
  "video-components-external": "/video-components-external/static-1.11919",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3538",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3573",
  "quartz-webpack": "/quartz-webpack/static-1.3520",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.374",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7880",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8126",
  "laboratory-lib": "/laboratory-lib/static-3.7351",
  "onboarding-scopes": "/onboarding-scopes/static-1.6659",
  "seat-types-lib": "/seat-types-lib/static-1.458",
  "ui-addon-opt": "/ui-addon-opt/static-4.8561",
  "HeadJS": "/HeadJS/static-2.780",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3335",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.220",
  "ts-schema": "/ts-schema/static-1.4219",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8056",
  "content-media-capture": "/content-media-capture/static-1.5146",
  "cssUtils": "/cssUtils/static-1.849",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10025",
  "file-manager-components": "/file-manager-components/static-1.24209",
  "HubStyle": "/HubStyle/static-2.11981",
  "knowledge-content-types": "/knowledge-content-types/static-1.8591",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10085",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11346",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9280",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10461",
  "video-data-lib": "/video-data-lib/static-1.35577",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4524",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6465",
  "customer-data-properties": "/customer-data-properties/static-1.52263",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18993",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5283",
  "onboarding-tours": "/onboarding-tours/static-1.16968",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8297",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9276",
  "user-context": "/user-context/static-1.5311",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.857",
  "hubspotter-http": "/hubspotter-http/static-1.4790",
  "icons": "/icons/static-2.667",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.554",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.971",
  "quartz-head": "/quartz-head/static-1.961",
  "quartz-test": "/quartz-test/static-1.971",
  "quartz-tracking": "/quartz-tracking/static-1.675",
  "trellis-components": "/trellis-components/static-1.2348",
  "ui-fonts": "/ui-fonts/static-1.936",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.5",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9626",
  "data-token-picker": "/data-token-picker/static-1.16748",
  "FileManagerLib": "/FileManagerLib/static-1.39849",
  "property-translator": "/property-translator/static-1.5595",
  "atom": "/atom/static-1.5276",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6208",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5790",
  "react-create-root-preference": "/react-create-root-preference/static-1.49",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1211",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4576",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2329",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3122",
  "foundations-theming-base": "/foundations-theming-base/static-1.3624",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4956",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-session-replay-endpoint-migration.5",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.268",
  "chirp-fetch": "/chirp-fetch/static-1.2087",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4677",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4853",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12950",
  "content-media-compositions": "/content-media-compositions/static-2.16957",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4347",
  "magpie-lib": "/magpie-lib/static-1.5692",
  "magpie-types": "/magpie-types/static-1.5152",
  "media-bridge-lib": "/media-bridge-lib/static-1.19267",
  "bender-build-tools": "/bender-build-tools/static-1.3321",
  "usage-tracker-public": "/usage-tracker-public/static-1-session-replay-endpoint-migration.5",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3985",
  "superstore": "/superstore/static-1.4958",
  "feedback-loader": "/feedback-loader/static-1.29658",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9459",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8906",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29112",
  "ContentUtils": "/ContentUtils/static-1.68942",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4625",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4815",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1423",
  "copilot-toolkit": "/copilot-toolkit/static-1.11646",
  "avatar-components": "/avatar-components/static-1.2698",
  "navigation-messaging": "/navigation-messaging/static-1.7911",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8376",
  "commerce-products-lib": "/commerce-products-lib/static-1.10276",
  "crm-message-bus": "/crm-message-bus/static-1.43539",
  "growth-data-modal": "/growth-data-modal/static-1.5750",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5078",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5182",
  "batch-promise": "/batch-promise/static-1.1745",
  "calling-global-api": "/calling-global-api/static-1.65181",
  "calling-internal-common": "/calling-internal-common/static-1.31514",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66563",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58857",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3936",
  "crm-links": "/crm-links/static-1.6517",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4399",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4277",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13233",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9767",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8296",
  "external-options-client-types": "/external-options-client-types/static-1.4266",
  "formula-editor": "/formula-editor/static-1.14602",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7094",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.379",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4356",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.831",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3830",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49394",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4106",
  "property-value-citations": "/property-value-citations/static-1.2877",
  "pulse": "/pulse/static-1.816",
  "smart-property-lib": "/smart-property-lib/static-1.8090",
  "tiered-pricing": "/tiered-pricing/static-1.1768",
  "topics-actions-lib": "/topics-actions-lib/static-1.354",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11190",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3261",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2492",
  "navigation-components": "/navigation-components/static-1.18584",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1034",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7842",
  "ui-universal-auth": "/ui-universal-auth/static-1.9217",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18111",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10438",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.5",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1151",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6206",
  "FileManagerCore": "/FileManagerCore/static-1.39708",
  "FileManagerImages": "/FileManagerImages/static-1.37360",
  "video-components": "/video-components/static-1.13921",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1332",
  "purchase-motions-api": "/purchase-motions-api/static-1.6211",
  "signup-constants": "/signup-constants/static-1.19367",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8258",
  "reactive-lib": "/reactive-lib/static-1.923",
  "simple-logging-lib": "/simple-logging-lib/static-1.3250",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22326",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6781",
  "cms-field-types": "/cms-field-types/static-1.5015",
  "content-icons-ui": "/content-icons-ui/static-1.2286",
  "integrations-lib": "/integrations-lib/static-1.16778",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.701",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.976",
  "customer-data-tracking": "/customer-data-tracking/static-1.7084",
  "products-iframe-lib": "/products-iframe-lib/static-1.8401",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10822",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1402",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2310",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.537",
  "calling-error-reporting": "/calling-error-reporting/static-1.31521",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11238",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6740",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1716",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7448",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9863",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6641",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6999",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10523",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "sales-views-client-types": "/sales-views-client-types/static-1.4457",
  "bark-lib": "/bark-lib/static-1.16694",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6087",
  "react-codemirror": "/react-codemirror/static-1.10839",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.213",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4146",
  "persist-promise": "/persist-promise/static-1.3902",
  "event-emitter": "/event-emitter/static-1.1150",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.319",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.504",
  "fsm": "/fsm/static-1.3932",
  "policy-lib": "/policy-lib/static-1.6988",
  "react-tinymce": "/react-tinymce/static-1.55770",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10586",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54896",
  "tinymce-plugins": "/tinymce-plugins/static-1.58010",
  "tinymce-themes": "/tinymce-themes/static-1.56866",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2520",
  "user-context-client": "/user-context-client/static-1.4751",
  "nest": "/nest/static-1.436",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1013",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4732",
  "video-embed": "/video-embed/static-1.36411",
  "social-insights-client-types": "/social-insights-client-types/static-1.22589",
  "flux-actions": "/flux-actions/static-1.354",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14193",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5807",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7978",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10565",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.731",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15351",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7805",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36493",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3723",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16148",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4707",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3241",
  "tinymce-data": "/tinymce-data/static-1.40981",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5412",
  "layout-dnd-components": "/layout-dnd-components/static-1.12819",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11794",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16012",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9190",
  "outpost": "/outpost/static-1.4366",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3211",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.246",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.764",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.823",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.929",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.268",
  "slack-ui-library": "/slack-ui-library/static-1.10598",
  "ContentData": "/ContentData/static-1.69017",
  "layout-data-lib": "/layout-data-lib/static-1.10119",
  "advanced-menus-core": "/advanced-menus-core/static-1.15447",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12341",
  "ExportDialog": "/ExportDialog/static-6.10579",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34601",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15446",
  "simple-menus-lib": "/simple-menus-lib/static-1.16963"
}
};
